import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const orig = err.config || {};
    if (err.response?.status === 401 && !orig._retry && !String(orig.url || "").includes("/auth/")) {
      orig._retry = true;
      refreshing = refreshing || api.post("/auth/refresh").finally(() => { refreshing = null; });
      try {
        await refreshing;
        return api(orig);
      } catch (e) { /* session gone */ }
    }
    return Promise.reject(err);
  }
);

export function errMsg(e) {
  const detail = e?.response?.data?.detail;
  if (detail == null) return e?.message || "Something went wrong";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((x) => (x && x.msg) || JSON.stringify(x)).join(" ");
  if (detail && Array.isArray(detail.conflicts)) return detail.conflicts.join("; ");
  if (detail && detail.msg) return detail.msg;
  // A structured 409 carries its sentence in `detail.detail` -- the demo-data
  // orphan guard and the payroll recompute warning both do. Without this the
  // fallback below stringifies the object and the user is shown the literal
  // text "[object Object]", which is how this was found.
  if (detail && typeof detail.detail === "string") return detail.detail;
  if (detail && typeof detail.error === "string") return detail.error;
  return String(detail);
}

export function conflictsOf(e) {
  const detail = e?.response?.data?.detail;
  return detail && Array.isArray(detail.conflicts) ? detail.conflicts : null;
}
